import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import RenderIf from '../../../RenderIf';
import { LastSessionNotice } from '../../Header.style';

const SEVEN_SECONDS = 7000;

const LastSessionInformer = ({ email, lastSessionDate }) => {
  const [showLastSession, setShowLastSession] = useState(true);

  useEffect(() => {
    let timeoutId;

    const initTimeout = () => {
      timeoutId = setTimeout(() => {
        setShowLastSession(false);
      }, SEVEN_SECONDS);
    };

    initTimeout();

    return () => {
      if (timeoutId) {
        clearTimeout(timeoutId);
      }
    };
  }, [setShowLastSession]);

  return (
    <RenderIf condition={showLastSession}>
      <LastSessionNotice>
        {'Último inicio de sesión '}

        <span data-heap-redact-text>{email}</span>

        {' el '}

        <span>{lastSessionDate.toLocaleDateString('es-MX', { dateStyle: 'medium' })}</span>

        {' a las '}

        <span>
          {lastSessionDate.toLocaleTimeString([], {
            hour: '2-digit', minute: '2-digit', hour12: true
          })}
        </span>
      </LastSessionNotice>
    </RenderIf>
  );
};

LastSessionInformer.propTypes = {
  email: PropTypes.string.isRequired,
  lastSessionDate: PropTypes.instanceOf(Date).isRequired
};

export default LastSessionInformer;
